export const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:5001";
export const IS_LOCAL = ['localhost','127.0.0.1'].includes(window.location.hostname);

export const TABS = {
  EMPLOYEES: 'employees',
  POLICIES: 'policies', 
  REQUESTS: 'requests',
  REPORTS: 'reports',
  ADJUSTMENTS: 'adjustments',
  DIGEST: 'digest',
  ONBOARDING: 'onboarding',
  ONBOARDING_OVERVIEW: 'onboarding-overview',
  REFERRALS: 'referrals',
  PROBATION_POLICIES: 'probation-policies',
  PROBATION_EXPIRIES: 'probation-expiries',
  DISMISSED: 'dismissed'
};

export const STATUS_FILTERS = {
  ALL: 'all',
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected'
};

export const SORT_ORDERS = {
  ASC: 'asc',
  DESC: 'desc'
};

export const POLICY_TYPES = {
  PTO: 'pto',
  SICK: 'sick'
};

export const COUNTRIES = [
  { value: 'US', label: 'United States' },
  { value: 'UK', label: 'United Kingdom' },
  { value: 'AUS', label: 'Australia' }
]; 